(function () {
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;

  var bound = new WeakSet();

  function bind(card) {
    if (bound.has(card)) return;
    bound.add(card);

    var rect = null;

    function onEnter() {
      rect = card.getBoundingClientRect();
      card.classList.add('sovyer-tilt');
    }

    function onMove(e) {
      if (!rect) rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width;
      var py = (e.clientY - rect.top) / rect.height;
      var rx = (0.5 - py) * 9;
      var ry = (px - 0.5) * 9;
      card.style.setProperty('--tilt-rx', rx.toFixed(2) + 'deg');
      card.style.setProperty('--tilt-ry', ry.toFixed(2) + 'deg');
    }

    function onLeave() {
      card.classList.remove('sovyer-tilt');
      card.style.setProperty('--tilt-rx', '0deg');
      card.style.setProperty('--tilt-ry', '0deg');
      rect = null;
    }

    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseleave', onLeave);
  }

  function init() {
    document.querySelectorAll('product-card').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
